import React, { Component } from 'react';
import { Trans } from "react-i18next";
import { NavLink } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Swiper from 'react-id-swiper';
import axios, { post } from 'axios';
import Cookies from 'universal-cookie';
import Loader from 'react-loader-spinner';
import "../../config/i18n";
import { withTranslation } from "react-i18next";
import ls from "local-storage"; 
import { options } from "../../config/options";
import * as ReactDom from 'react-dom'; 


class BannerView extends Component { 
    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
     
        this.state = {
           
            file: require("../../assets/img/cap1.png"),
            api_url:localStorage.getItem('api_url'),            
            lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'),
            user_id:JSON.parse(localStorage.getItem('session_userid')),
            bannerlist: [],
            currency:'',
             loadmore:'none'

        }
    }
      
    componentDidMount(){

      this.setState({
            loader:'loder-icon'
            });
            setTimeout(() => {
                this.setState({
                    profilespace: '',
                    loader: 'none'
                });
              }, 300);


        var datalist = new FormData();   
          datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
          datalist.set('language', this.state.langKey); 
          
          axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data' }}
              }).then(res => {

                if(res.data.status === 'true') {
                    this.setState({
                        currency: res.data.result.currency,
                        bannerperprice:res.data.result.bannerprice
                    });
                } else {
                    this.props.history.push("/login");   
                }


            });
       
        axios.get(this.state.api_url+`admindatas`)
        .then(res => {
           
            const datas = res.data.result;           
            const country_raw = res.data.result.country;
            var country = [];
            country_raw && country_raw.map((i,k)=>{
                // console.log('k ~ '+i.id);
                var country_each_index = {};
                country_each_index.value = i.id;
                country_each_index.label = i.name+' - '+i.currencycode;
                country.push(country_each_index);
            })
            
            this.setState({
                country,
                bannerdays:res.data.result.bannerdays,
                });

        })

        const { match: { params } } = this.props;

         var datalist = new FormData();   
         datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
         datalist.set('banner_id', params.bannerId); 
         datalist.set('language', this.state.langKey); 
               
          
          axios({
            method: 'post',
            url: this.state.api_url+'bannerviewweb',
            data: datalist,    
            config: { headers: {'Content-Type': 'multipart/form-data' }}
              }).then(res => {
                const data = res.data;
                //console.log(data.banner.totalCost);

                if(res.data.status === 'true') {
                    //alert(res.data.status);
                    this.setState({
                        bannerlist: data.banner,
                    });

                    localStorage.setItem('bannerprice',data.banner.totalCost);
                    localStorage.setItem('banner_id',data.banner.banner_id);   
                } else {
                     //alert(res.data.status); 
                }


            }); 
    
      }

    
    render() {

      var style = {
            zIndex:10,
            backgroundColor:"white",
            position:"absolute",
            height:"80vh",
            width:"100%",
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            //width:"100%",
            overflowY:"hidden"
          };

        

        return (
        
        <div className="rightSideContent">
         <div className="setting-page addsBanner">
          <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg">
            <div className="heading-left-top d-flex">
              <div className="align-self-center">
                <div className="iconHolder align-self-center mr-1">
                  <div className="backGlow d-block d-lg-none">
                    <div className="sideBarToggler sidebarIcoPos" />
                  </div>
                </div>
              </div>
               <div className="align-self-center ">
                                    <NavLink to="/app/Banner">
                                        <div className="iconHolder align-self-center mr-1">
                                            <div className="backGlow">
                                                <div className="backIco"></div>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
              <span className="arrow-center align-self-center ml-1 bold-font"><Trans i18nKey="Banner Advertise history">Banner Advertise history</Trans></span>
            </div>
            <div className="backGlow white-bg" />
          </div>
          <div className={this.state.loader}>
                        <div style={style} id="loader">
                            <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
                        </div>
                    </div>
          <div className="settingsPageWidth">
            <div className="setFiltBox">
              <div className="mb-4">
                <div className="text-truncate bold-font BtoRcolor mb-2">
                  <Trans i18nKey="Website Banner">Website Banner</Trans>
                </div>
                <img src={this.state.bannerlist.bannerimg} alt="" className="bannerImg" />
              </div>
              <div className="mb-4">
                <div className="text-truncate bold-font BtoRcolor mb-2">
                  <Trans i18nKey="Paid Ammount">Paid Ammount</Trans>
                </div>
                <div className="text-truncate  BtoRcolor mb-2">
                  {this.state.bannerlist.currency} {this.state.bannerlist.totalCost}
                </div>
              </div>
              {this.state.bannerlist.tranxId ? 
              <div className="mb-4">
                <div className="text-truncate bold-font BtoRcolor mb-2">
                  <Trans i18nKey="Transaction ID">Transaction ID</Trans>
                </div>
                <div className="text-truncate  BtoRcolor mb-2">
                  <Trans i18nKey={this.state.bannerlist.tranxId}>{this.state.bannerlist.tranxId}</Trans>
                </div>
              </div>
              : " "
            }
              <div className="mb-4">
                <div className="text-truncate bold-font BtoRcolor mb-2">
                  <Trans i18nKey="Up to">Up to</Trans>
                </div>
                <div className="text-truncate  BtoRcolor mb-2">
                  {this.state.bannerlist.startdate}  {"-"}
                     {this.state.bannerlist.enddate}  
                </div>
              </div>
              <div className="mb-4">
                <div className="text-truncate bold-font BtoRcolor mb-2">
                  <Trans i18nKey="Country">Country</Trans>
                </div>
                <div className="text-truncate  BtoRcolor mb-2">
                  {this.state.bannerlist.country}
                </div>
              </div>
              <div className="mb-4">
                <div className="text-truncate bold-font BtoRcolor mb-2">
                  <Trans i18nKey="Gender">Gender</Trans>
                </div>
                <div className="text-truncate  BtoRcolor mb-2">
                  {this.state.bannerlist.gender == 0 ? <Trans i18nKey="Male">Male</Trans> : <Trans i18nKey="Female">Female</Trans>}
                </div>
              </div>
              <div className="mb-4">
                <div className="text-truncate bold-font BtoRcolor mb-2">
                  <Trans i18nKey="Status">Status</Trans>
                </div>
                <div className="text-truncate  redcolor mb-2">
                  {this.state.bannerlist.status == 0 ? <Trans i18nKey="Pending ">Pending </Trans> :
                  this.state.bannerlist.status == 1 ? <Trans i18nKey="Accepted ">Accepted</Trans> :
                  this.state.bannerlist.status == 2  ? <Trans i18nKey="Rejected ">Rejected </Trans> : <Trans i18nKey="Expired">Expired</Trans>}
                </div>
              </div>

              <div className="mb-4">
                <div className="text-truncate bold-font BtoRcolor mb-2">
                  <Trans i18nKey="Paid Status">Paid Status</Trans>
                </div>
                <div className="text-truncate  redcolor mb-2">
                  {this.state.bannerlist.paidstatus == 0 ? <Trans i18nKey="UnPaid">UnPaid</Trans> : <Trans i18nKey="Paid">Paid</Trans>}
                </div>
              </div>

               {this.state.bannerlist.paidstatus == 0 && this.state.bannerlist.expystatus == 'yes'  &&  this.state.bannerlist.status == 1  ?      
               <NavLink to={{
                                pathname:'/app/WalletPayment',
                                paytype: {type:'banner'} 
                            }}>           
                 <button className="btn-common add_wallet_btn w-100">
                <Trans i18nKey="Pay">Pay</Trans>
              </button>
              </NavLink>
              :  " "
            }
            </div>
          </div>
        </div>
      </div>
            
        )
    }
}

export default withTranslation("translations")(BannerView);
